// Integration Types (Google Analytics only for now)
export const INTEGRATION_TYPES = {
  ANALYTICS: 1,
  CONTENT_GENERATION: 7,
};

// Google Analytics is the only provider for now
export const ANALYTICS_PROVIDERS = {
  GOOGLE_ANALYTICS: "google_analytics",
};
//
export const CONTENT_GENERATION_PROVIDERS = {
  GEMINI: "Google_Gemini",
};

// Integration Status (simplified - no syncing/testing)
export const INTEGRATION_STATUS = {
  ACTIVE: 1,
  INACTIVE: 2,
  FAILED: 3,
  PENDING: 4,
};

// Google Analytics Configuration Fields (only Measurement ID)
export const GOOGLE_ANALYTICS_FIELDS = {
  MEASUREMENT_ID: "measurement_id",
};
//

export const INTEGRATION_TYPE_LABELS = {
  [INTEGRATION_TYPES.ANALYTICS]: "Analytics",
  [INTEGRATION_TYPES.CONTENT_GENERATION]: "Generative AI",
};

export const ANALYTICS_PROVIDER_LABELS = {
  [ANALYTICS_PROVIDERS.GOOGLE_ANALYTICS]: "Google Analytics",
  [CONTENT_GENERATION_PROVIDERS.GEMINI]: "Google Gemini",
};

export const GEMINI_FIELDS = {
  API_KEY: "api_key",
  
};
